import { Box, Paper, Typography } from '@mui/material'

function MaintenanceScreen() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
        color: '#f8fafc',
        px: 3,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: '100%',
          maxWidth: 700,
          p: { xs: 4, md: 6 },
          textAlign: 'center',
          backgroundColor: 'rgba(15, 23, 42, 0.78)',
          border: '1px solid rgba(148, 163, 184, 0.35)',
          borderRadius: 3,
          boxShadow: '0 30px 80px rgba(15, 23, 42, 0.5)',
        }}
      >
        <Typography
          variant="h2"
          component="h1"
          sx={{
            fontWeight: 800,
            letterSpacing: 0.5,
            mb: 2,
          }}
        >
          [Down for maintance]
        </Typography>

        <Typography variant="body1" sx={{ color: '#cbd5e1', lineHeight: 1.7 }}>
          We are currently performing scheduled maintenance. Please check back soon.
        </Typography>
      </Paper>
    </Box>
  )
}

export default MaintenanceScreen
